<template>
  <div class="container1">
    <div class="introduce">
      <h2 style="color: black;font-size: 36px">为什么选择我们?</h2>
      <div style="color: #9A9A9A;font-size: 18px;margin-top: 10px">靠谱平台 · 高效撮合 · 百万用户信赖</div>
      <div style="display: flex;flex-direction: row;margin-top: 60px">
        <img src="@/assets/img/findjob.png" style="width: 337px;height: 481px">
        <div style="display: flex;flex-direction: column;margin-left: auto;justify-content: space-between">
          <div style="display: flex;flex-direction: row;text-align: left">
            <img src="@/assets/img/introduce1.png" class="img">
            <div style="display: flex;flex-direction: column;">
              <div class="title">海量岗位</div>
              <div class="desc">岗位众多，全国覆盖，<span style="font-weight: bold">餐饮 / 物流 / 教育 </span>等多行业选择</div>
            </div>
          </div>
          <div style="display: flex;flex-direction: row;text-align: left">
            <img src="@/assets/img/introduce1.png" class="img">
            <div style="display: flex;flex-direction: column;">
              <div class="title">企业资质审核</div>
              <div class="desc">凡是平台内入驻的企业都必须提交企业营业执照信息、身份证信息等多方材料，经审核部门审核无误后方可入驻，保障每份兼职信息真实可查，有据可依</div>
            </div>
          </div>
          <div style="display: flex;flex-direction: row;text-align: left">
            <img src="@/assets/img/introduce1.png" class="img">
            <div style="display: flex;flex-direction: column;">
              <div class="title">高效撮合</div>
              <div class="desc">推荐匹配 + 实时报名通知<br>商家快速找到合适人才，用户高效拿到工作</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FindJobIntroduce',
};
</script>
<style scoped>
.introduce {
  text-align: center;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.img {
  width: 81px;
  height: 81px;
  margin-right: 35px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  color: black;
}

.container1{
  padding: 60px 36px 60px 168px;
}

.desc {
  width: 628px;
  font-size: 23px;
  color: #9A9A9A;
}
</style>
